export const INITIAL = 'initial';
export const AWAITING_AUTH = 'awaitingAuth';
export const LEARNOSITY_UP = 'learnosityUp';
export const LEARNOSITY_DOWN = 'learnosityDown';